import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'shared/shared.module';

import { PromptuaryFillingInstructionsWarningModule } from '../promptuary-instructions-filling-warning/promptuary-filling-instructions-warning.module';
import { PromptuaryServiceEvolutionComponent } from './promptuary-service-evolution.component';

@NgModule({
	declarations: [PromptuaryServiceEvolutionComponent],
	imports: [
		CommonModule,
		PromptuaryFillingInstructionsWarningModule,
		TranslateModule,
		SharedModule,
	],
	exports: [PromptuaryServiceEvolutionComponent],
	providers: [],
})
export class PromptuaryServiceEvolutionModule {}
